import React from 'react';

const NotFoundPage = () => (
  <main className="page page--booking">
    <header className="hero hero--fun">
      <div className="hero-title">
        <h1>Page not found</h1>
      </div>
      <p className="subtitle">
        The page you requested is unavailable. Check the link and try again, or return to bookings.
      </p>
    </header>

    <section className="panel card card--soft">
      <div className="stack">
        <p className="muted">This link does not match an active store page, event page, or booking resource.</p>
        <div>
          <a className="btn btn-primary" href="/">
            Go to bookings
          </a>
        </div>
      </div>
    </section>
  </main>
);

export default NotFoundPage;
